import { map } from '@sama/micro-dash';
import { ObjectWith } from '../../cross-team-shared/types/misc';
import { Project } from '../../team-apis/otterdam/project';

export function createDefaultSamplingLayout(project: Project) {
  const h3Outputs: ObjectWith<JQuery> = {};
  for (const step of project.steps) {
    const layoutDocument = new DOMParser().parseFromString(
      step.layout,
      'text/html',
    );
    layoutDocument.body
      .querySelectorAll<HTMLElement>('h3-output,h3-sensor-fusion')
      .forEach((stepVersion) => {
        const $stepVersion = $(stepVersion);
        let name: string | undefined;
        if (stepVersion.closest('h3-sensor-fusion')) {
          name = ($stepVersion.attr('fused-outputs') ||
            $stepVersion.attr('[outputs]') ||
            $stepVersion.attr('fusion-outputs'))!;
          h3Outputs[name] = $stepVersion;
        } else {
          name = $stepVersion.attr('name')!;
          // fix me if you change this code
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix me!
          if (!h3Outputs[name]) {
            h3Outputs[name] = $('<h3-output>')
              .attr('name', name)
              .html($stepVersion.html());
          }
        }
        addShowHideLogic(h3Outputs[name], $stepVersion);
      });
  }
  return map(h3Outputs, (output) => $('<div>').append(output).html()).join('');
}

// if an output can be shown/hidden _on the last step on which it exists_,
// apply the same logic in the sampling workspace
function addShowHideLogic($samplingVersion: JQuery, $stepVersion: JQuery) {
  const hideExpressions = $stepVersion
    .parents('[h3-show-only-when]')
    .addBack('[h3-show-only-when]')
    .toArray()
    .map((hider) => $(hider).attr('h3-show-only-when'));

  if (hideExpressions.length) {
    $samplingVersion.attr(
      'h3-show-only-when',
      `(${hideExpressions.join(') && (')})`,
    );
  } else {
    $samplingVersion.removeAttr('h3-show-only-when');
  }
}
